import {SupplementalType, supplementalTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<SupplementalType>;

export const SupplementalTypeSelect = (props: Props) => {
  const {options = supplementalTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
